<template>
  <v-card :class="[$root.device.isMobile ? 'mobileContent' : 'fullContentRTL']">
    <v-layout class="fullToolbar" style="width: 100%; height: 80px;">
      <v-flex xs9 right>
        <v-layout row wrap style="width: 100%; padding-top: 15px; color: #fff;">
          <v-flex xs3 right>
            <i class="material-icons icon" style="font-size: 30px; padding: 10px; float: right;">business_center</i>
            <p style="font-size: 30px;float: right;">{{$t('projects')}}</p>
          </v-flex>
          <v-flex xs3 right>
            <v-layout row wrap style="width: 100%; padding-top: 10px; color: #fff;">
              <v-flex xs2 right>
                <v-icon dark v-tooltip:bottom="{ html: 'הצג מפה' }" v-if="!isMap" @click="isMap=!isMap">place</v-icon>
                <v-icon dark v-tooltip:bottom="{ html: 'הצג רשימה' }" v-else @click="isMap=!isMap">list</v-icon>
              </v-flex>
              <v-flex xs6>
                <span class="custom-dropdown custom-dropdown--white" style="float: right;">
                  <select v-model="selectedStatus" class="custom-dropdown__select custom-dropdown__select--white">
                    <option value="-1" disabled="disabled">סינון שלב התקדמות</option>
                    <option value="">הצג הכל</option>
                    <option v-for="status in statuses" :value="status['.key']">{{status.Name}}</option>
                  </select>
                </span>
              </v-flex>
              <v-flex xs3>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs3 right>
            <p style="font-size: 20px;float: right; padding-top: 10px;">נמצאו: {{counter}} פרויקטים</p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs3 left>
        <v-text-field v-if="!$root.device.isMobile" dark prepend-icon="search" single-line style="padding-top: 20px;" v-model="txtSearch"></v-text-field>
        <v-icon v-else @click="$root.activeMobileMenu=true" class="btnIcon mr-2 ml-2">menu</v-icon>
      </v-flex>
    </v-layout>
    <TableProjects v-if="!isMap"></TableProjects>
    <DataMap v-else></DataMap>
    <PopupProject></PopupProject>
  </v-card>
</template>

<script>
  import { db } from '../firebase';
  var projectsRef = db.ref('Projects');
  var statusesRef = db.ref('Statuses');

  import Toolbar from '../components/Toolbar';
  import TableProjects from '../components/TableProjects';
  import DataMap from '../components/DataMap';
  import PopupProject from '../components/PopupProject';

  export default {
    name: 'Projects',
    components: {
      Toolbar,
      TableProjects,
      DataMap,
      PopupProject
    },
    data() {
      return {
        txtSearch: '',
        selectedStatus: '',
        isMap: false,
        projects: [],
        statuses: [],
        isActiveUsers: false,
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: {
            '.key': '',
            Name: '',
            City: '',
            Address: '',
            Location: { lat: 0, lng: 0 },
            Info: '',
            StatusKey: '',
            UserKey: '',
            Active: true,
            Images: [],
            CreateDate: '',
            UpdateDate: ''
          },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        projects: vm.$root.isAdmin ? projectsRef.orderByKey() : projectsRef.orderByChild("UserKey").equalTo(vm.$root.user['.key']),
        statuses: statusesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [Projects] is created ...");
      if (this.$root.user.Type != "מנהל מערכת" && this.$root.user.Type != "רוכש") {
        this.$router.push({ name: 'MyDiaries' });
      }
    },
    ready() {
      this.$Log("Vue [Projects] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Projects] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Projects] is updated ...");
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        var filteredProjects = vm.projects.filter(function (row) {
          if (vm.selectedStatus == "") {
            return true;
          }
          else {
            return row.StatusKey == vm.selectedStatus;
          }
        });
        if (vm.txtSearch.length > 0) {
          var result = [];
          try {
            var rowsCount = 0;
            result = filteredProjects.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (key != "logo") {
                  if (key == "Entrepreneur") {
                    if (String(row[key].FullName).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                      rowsCount++;
                      return row;
                    }
                  }
                  else {
                    if (String(row[key]).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1) {
                      rowsCount++;
                      return row;
                    }
                  }
                }
              })
            });
          }
          catch (e) {
          }
        }
        else {
          var result = filteredProjects;
        }

        if (result && result.length > 0) {
          for (var r = 0; r < result.length; r++) {
            result[r].Percent = vm.calcProgress(result[r]); //"0 %";
            result[r].zIndex = 5000;
          }
        }

        return result;
      },
      counter() {
        return this.filteredRows.length;
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveProject') {
          this.remove();
        }
      }
    },
    methods: {
      calcProgress(row) {
        var startDate = this.$moment(row.StartDate, 'DD/MM/YYYY');
        var endDate = this.$moment(row.EndDate, 'DD/MM/YYYY');
        var today = this.$moment();
        var totalDays = 0;
        var duration;

        duration = this.$moment.duration(endDate.diff(startDate));
        var daysProject = duration.asDays();

        duration = this.$moment.duration(today.diff(startDate));
        var daysStarted = duration.asDays();

        duration = this.$moment.duration(endDate.diff(today));
        var daysEnded = duration.asDays();

        //console.log("Total Days = " + daysProject);
        //console.log("Passed Days = " + daysStarted);
        var percent = 0;

        if (daysStarted <= 0) {
          percent = 0;
        }
        else if (daysEnded <= 0) {
          percent = 100;
        }
        else {
          percent = (daysStarted / daysProject) * 100;
        }

        //console.log("Percent = " + percent + " %");
        //console.log("Percent (round) = " + Math.round(percent, 0) + " %");
        //console.log("================================================");
        return Math.round(percent, 0);
      },
      getStatusColor(statusKey) {
        var selectedColor = '#F7941D';
        for (var i = 0; i < this.statuses.length; i++) {
          if (this.statuses[i]['.key'] == statusKey) {
            selectedColor = this.statuses[i].Color;
            break;
          }
        }
        return selectedColor;
      },
      getStatusName(statusKey) {
        var selectedName = '';
        for (var i = 0; i < this.statuses.length; i++) {
          if (this.statuses[i]['.key'] == statusKey) {
            selectedName = this.statuses[i].Name;
            break;
          }
        }
        return selectedName;
      },
      addNew(location) {
        if (location == null || location == undefined) {
          location = { lat: 0, lng: 0 };
        }
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'פרויקט חדש',
          data: {
            '.key': '',
            Name: '',
            City: '',
            Address: '',
            Location: location,
            Info: '',
            StatusKey: '',
            UserKey: this.$root.user['.key'],
            Active: true,
            Images: [],
            CreateDate: '',
            UpdateDate: '',
            StartDate: this.$moment().format("YYYY-MM-DD"),
            EndDate: this.$moment().format("YYYY-MM-DD"),
            Entrepreneur: { UserKey: '', FullName: '' }
          }
        };
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת פרויקט',
          data: {
            '.key': row['.key'],
            Name: row.Name,
            City: row.City,
            Address: row.Address,
            Location: row.Location,
            Info: row.Info,
            StatusKey: row.StatusKey,
            UserKey: row.UserKey,
            Active: row.Active,
            Images: row.Images,
            CreateDate: row.CreateDate,
            UpdateDate: this.$moment().format('DD/MM/YYYY'),
            StartDate: this.$moment(row.StartDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
            EndDate: this.$moment(row.EndDate, 'DD/MM/YYYY').format("YYYY-MM-DD"),
            Entrepreneur: row.Entrepreneur ? row.Entrepreneur : { UserKey: '', FullName: '' }
          }
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveProject',
          isConfirmed: false
        }
      },
      remove() {
        projectsRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var item = {
          Name: this.popup.data.Name,
          City: this.popup.data.City,
          Address: this.popup.data.Address,
          Location: this.popup.data.Location,
          Info: this.popup.data.Info,
          StatusKey: this.popup.data.StatusKey,
          UserKey: this.popup.data.UserKey,
          Active: this.popup.data.Active,
          Images: this.popup.data.Images,
          CreateDate: this.$moment().format('DD/MM/YYYY'),
          UpdateDate: this.$moment().format('DD/MM/YYYY'),
          StartDate: this.$moment(this.popup.data.StartDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
          EndDate: this.$moment(this.popup.data.EndDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
          Entrepreneur: this.popup.data.Entrepreneur,
        };
        projectsRef.push(item);
      },
      update() {
        var item = {
          Name: this.popup.data.Name,
          City: this.popup.data.City,
          Address: this.popup.data.Address,
          Location: this.popup.data.Location,
          Info: this.popup.data.Info,
          StatusKey: this.popup.data.StatusKey,
          UserKey: this.popup.data.UserKey,
          Active: this.popup.data.Active,
          Images: this.popup.data.Images,
          CreateDate: this.popup.data.CreateDate,
          UpdateDate: this.popup.data.UpdateDate,
          StartDate: this.$moment(this.popup.data.StartDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
          EndDate: this.$moment(this.popup.data.EndDate, "YYYY-MM-DD").format('DD/MM/YYYY'),
          Entrepreneur: this.popup.data.Entrepreneur,
        };
        projectsRef.child(this.popup.data['.key']).set(item);
      },
    }
  }

</script>
<style>
  .RTL {
    text-align: right;
  }

    .RTL > tr > td {
      text-align: right;
    }

  .iconArrow2RTL {
    left: -220px;
  }

  .toolbar__title i {
    color: #fff;
    font-size: 30px;
  }

  .toolbar .toolbar__content {
    width: 100% !important;
  }

  .trHeader {
    background-color: #3A2D01 !important;
    color: #fff !important;
  }

  .trRow {
    background-color: #3A2D01 !important;
    color: #fff !important;
  }

  th {
    color: #fff !important;
  }

  td.tdTxt {
    color: #3A2D01 !important;
  }

    td.tdTxt > i {
      color: #3A2D01 !important;
    }

  .lblTop {
    color: #888;
    font-size: 11px;
    display: block;
    text-align: left;
  }

  .lblTopRTL {
    color: #888;
    font-size: 11px;
    display: block;
    text-align: right;
  }

  .smallRemove {
    float: right;
    padding-left: 10px;
    padding-top: 5px;
    cursor: pointer;
  }

  .btnSend {
    height: 35px;
  }

  .tabs__items {
  }

  .tabs__item {
    text-transform: none !important;
    background-color: #f2f2f2;
    color: #02589B !important;
    border-bottom: 2px solid #02589B;
    padding: 0px 10px !important;
  }

  .divOr {
    color: #02589B;
    text-align: center;
    width: 100%;
  }

  .noData {
    padding: 30px;
    width: 100%;
    text-align: center !important;
    font-size: 20px;
    color: #ccc;
  }

  .cardBlue {
    margin: 0px;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
  }

  .blueTitle {
    width: 96%;
    text-align: left;
  }

  .blueTitleRTL {
    width: 96%;
    text-align: right;
  }

  .blueLink {
    text-align: right;
    font-size: 25px;
    font-weight: lighter;
    color: #fff !important;
    cursor: pointer;
  }

  .lblCommunity {
    font-size: 14px;
    width: 100%;
    text-align: left;
    display: block;
  }

  .lblCommunityRTL {
    font-size: 14px;
    width: 100%;
    text-align: right;
    display: block;
  }

  .imgUser {
    width: 50px;
    height: 50px;
    border-radius: 50px;
  }

  .cardBlue .card__title {
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0px;
    background-color: rgb(1, 87, 155);
    height: 40px !important;
    font-size: 13px;
    color: #fff;
  }

  .dialog > .card .card__title {
    padding: 10px;
  }

  .tblUsers {
    width: 100%;
    border-spacing: 0px;
    border-collapse: collapse;
  }

  table.tblUsers > thead > tr {
    border-bottom: 2px solid #ccc;
  }

    table.tblUsers > thead > tr > td {
      color: #02589B;
      font-weight: bold;
      border-bottom: 2px solid #ccc;
      text-align: left;
      padding-bottom: 10px;
    }

  table.tblUsers > tbody > tr > td {
    text-align: left;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
  }

  .avatar {
    text-align: center;
    width: 70px;
  }

  .edit {
    width: 30px;
  }

    .edit > i {
      color: #02589B !important;
      cursor: pointer;
      font-size: 30px;
    }

  .overlay--active {
    z-index: 19000 !important;
  }

  .dialog__content {
    z-index: 20000 !important;
  }

  .input-group__input {
    border: none !important;
  }

  .divTabs {
    width: auto;
    border-bottom: 2px solid #01579B;
    margin: 5px 20px 10px 20px;
  }

  .divTabContent {
    height: 400px;
  }

  .tabTitle {
    color: #999;
    line-height: 40px;
    display: block;
    cursor: pointer;
  }

    .tabTitle:hover {
      color: #02589B;
    }

  .arrow {
    position: relative;
    color: #02589B;
  }

    .arrow:after {
      border: solid transparent;
      content: " ";
      display: block;
      height: 0;
      position: absolute;
      pointer-events: none;
      width: 0;
      top: 100%;
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #02589B;
      left: 50%;
      margin-left: -10px;
      border-width: 10px;
    }

  .divLogo {
    color: #c9c9c9;
    background-color: #e4e4e4;
    width: 60px;
    height: 60px;
    border-radius: 100%;
    line-height: 60px;
    font-size: 20px;
  }

  .iconArrow2 {
    opacity: 1;
    position: relative;
    top: -30px;
    left: 210px;
    color: #999999;
    font-size: 20px;
  }

  .chk {
    padding-top: 5px;
  }

  .chkRTL {
    padding-top: 10px;
    margin-top: 7px;
    margin-left: 5px;
  }

  .chkSpan {
    color: #999999;
    padding-left: 10px;
    font-size: 13px;
  }

  .chkSpanRTL {
    text-align: right;
  }

  .sideLeft {
    float: left;
    padding-left: 10px;
    padding-top: 15px;
    font-weight: normal;
    padding: 15px;
  }

    .sideLeft > i {
      font-size: 20px;
      padding-bottom: 5px;
    }

    .sideLeft > span {
      padding-top: 15px;
      margin-top: 15px;
    }

  .sideRight {
    float: right;
    padding-top: 15px;
    font-weight: normal;
    padding: 15px;
  }

    .sideRight > i {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 4px;
    }

    .sideRight > span {
    }
</style>



// WEBPACK FOOTER //
// Projects.vue?724d40d7